"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrency = exports.getCurrencies = void 0;
const getCurrencies = async (supabase) => {
    const { data, error } = await supabase
        .from("currencies")
        .select(`*`)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getCurrencies = getCurrencies;
const getCurrency = async (supabase, id) => {
    const { data, error } = await supabase
        .from("currencies")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getCurrency = getCurrency;
